import * as yup from 'yup';
export const pageSizeSchema = yup
    .number()
    .nullable()
    .min(1, 'minValue')
    .max(500, 'maxValue')
    .typeError('invalid');
export const followUpReasonSchema = yup
    .string()
    .nullable()
    .max(30, 'max30Chars');
